// import dayjs from 'dayjs';

const dictionary = {
	de: {
		// format: (ctx) => {
		// 	console.log('formatting with dayjs');
		// 	const value = ctx.named('value');
		// 	const dateType = ctx.named('date');
		// 	if (dateType === 'normal') {
		// 		dayjs(value).format('DD.MM.YYY');
		// 		return 'good';
		// 	}
		// 	return 'error';
		// },
	},
};

export default dictionary;
